/** @format */

import React from 'react';
import { Grid, Typography, Card, CardContent } from '@mui/material';
import { useStylesDocsList } from './style';
import { Empty, LoadingPage, Icons } from 'components';
import DocItem from './DocItem';

export default function DocsList({ files, refreshList, loading, disableDelete, docTypes = [] }) {
  // --HOOKS--//
  const classes = useStylesDocsList();

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h4">
        اسناد بارگزاری شده
      </Typography>

      {disableDelete ? (
        <Card className={classes.helpCard}>
          <CardContent className={classes.helpContent}>
            <Grid container>
              <span className={classes.helpIcon}>
                <Icons icon='Info' color='#667585' hover='#667585' size='20' />
              </span>
              <Typography className={classes.helpText} color="textSecondary">
                امکان حذف اسناد بارگزاری شده، برای کسب‌و‌کارهای تایید شده وجود ندارد.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
      ) : null}
      {loading ? (
        <LoadingPage />
      ) : (
        <Grid container item xs={12} spacing={3} className={classes.docItemsContainer}>
          {files ? (
            files.length > 0 ? (
              files.map((v, k) => (
                <DocItem
                  key={k}
                  file={v}
                  refreshList={refreshList}
                  disableDelete={disableDelete}
                  docTypes={docTypes}
                />
              ))
            ) : (
              <Grid
                container
                item
                xs={12}
                direction="column"
                alignItems="center"
                justifyContent="center"
                className={classes.empty}
              >
                <Empty label="سندی یافت نشد!" />
              </Grid>
            )
          ) : null}
        </Grid>
      )}
    </div>
  );
}
